const Status = {
  Uploading: 'Uploading',
  Done: 'Done',
};

export default Status;
